<template>
  <v-app id="vuetify-app">
    <v-container fluid>
      <v-layout align-center justify-center row fill-height>
        <v-flex xs12 md4>
          <v-card>
            <v-card-title>
              <h3>
                {{ `app.reset_password` | trans }}
              </h3>
            </v-card-title>
            <v-card-text>
              <v-alert :value="passwordResetSuccessful" type="success">
                {{ `passwords.sent` | trans }}
              </v-alert>
              <v-form v-model="formValid" lazy-validation ref="resetPasswordForm">
                <v-text-field
                    v-model="userData.email"
                    :label="`app.email` | trans "
                    :rules="rules.email"
                ></v-text-field>
                <recaptcha :recaptcha-site-key="recaptchaSiteKey" ref="recaptcha"/>
                <v-btn :disabled="!formValid || loading" :loading="loading" color="primary"
                       @click="resetPassword">{{ `app.reset_password` | trans }}
                </v-btn>
              </v-form>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </v-app>
</template>

<script>
import axios from "axios";
import {trans} from "../../app";
import RulesBuilder from "../../utils/rulesBuilder";

export default {
  props: {
    email: String,
    recaptchaSiteKey: String,
    routes: Object,
  },
  data() {
    return {
      loading: false,
      formValid: false,
      userData: {
        email: "",
      },
      passwordResetSuccessful: false,
      rulesBuilder: new RulesBuilder(),
    };
  },
  mounted() {
    this.userData.email = this.email;
  },
  computed: {
    rules() {
      return {
        email: this.rulesBuilder.addRequiredRule(trans('app.email'))
            .addMaxLengthRule(trans('app.email'), 255)
            .getRules(),
      }
    }
  },
  methods: {
    resetPassword() {
      this.loading = true;
      if (this.$refs.resetPasswordForm.validate() === false) {
        this.loading = false;
        return;
      }

      if (this.$refs.recaptcha.verify() === false) {
        this.loading = false;
        return;
      }
      this.passwordResetSuccessful = false;
      axios.post(this.routes.reset_password, {
        email: this.userData.email,
        g_recaptcha_response: this.$refs.recaptcha.getResponse(),
      }).then(() => {
        this.passwordResetSuccessful = true;
        this.loading = false;
      }).catch(() => {
        this.loading = false;
        this.$toast.error(trans('app.mobile_app.password_reset.password_reset_failed'));
      })
    }
  }
};
</script>
